const searchToggle = () => {
    let selettoriFiltriSearchInput = document.querySelectorAll(".filters-item.--search .filter-search__input");
    const searchInput = document.querySelector(".filter-search__input input")
    const items = document.querySelectorAll(".filter-search__list li")

    selettoriFiltriSearchInput.forEach(el => {
        /* FOCUS MOSTRA LISTA */
        el.addEventListener("click", e => {
            let isVisible = el.closest(".filters-item").classList.contains('visible-list');
            el.closest(".filters-item").classList.toggle('visible-list',!isVisible);
        });
    });

    /* click fuori da input nasconde */
    window.addEventListener('mouseup', function(e){   
        selettoriFiltriSearchInput.forEach(el => {
            if (!el.contains(e.target) && el.closest(".filters-item").classList.contains('visible-list')){
                el.closest(".filters-item").classList.remove('visible-list');
            }
        });
        
    });
    let noresults;
    //Search Autocomplete
    searchInput.addEventListener("input", e => {
        const value = e.target.value.toLowerCase()
        items.forEach(item => {
            let name = item.querySelector('a').innerText
            const isVisible = name.toLowerCase().includes(value)
            item.classList.toggle("d-none", !isVisible)
            item.classList.toggle("filter-search__list-item", isVisible)
        })
        if(!document.querySelector('.filter-search__list-item')){
            document.querySelector('.filter-search__list-item-nores').classList.remove("d-none")
        }else{
            document.querySelector('.filter-search__list-item-nores').classList.add("d-none")
        }
    })
    
}

export default searchToggle;
